<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        盘点审核
      </div>
    </div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/d1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.notCheckCount }}</div>
          <div class="a3">待审核(条)</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/d2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.allCheckCount }}</div>
          <div class="a3">总计盘点数(次)</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="选择状态">
        <el-select v-model="state" placeholder="全部">
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="输入搜索" prop="name">
        <el-input v-model="keyword" placeholder="请输入仓库名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchakancx">查询</el-button>
        <el-button @click="getchozi">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="仓库编号" prop="houseId"> </el-table-column>

      <el-table-column label="仓库名称" prop="houseName"> </el-table-column>

      <el-table-column label="原次品总数" prop="oldDefCount"> </el-table-column>

      <el-table-column label="变更次品总数为" prop="realDefCount">
      </el-table-column>

      <el-table-column label="原当前库存数" prop="oldStockCount">
      </el-table-column>

      <el-table-column label="变更当前库存数为" prop="realStockCount">
      </el-table-column>

      <el-table-column label="提交时间" prop="addtime"> </el-table-column>

      <el-table-column label="状态" prop="state">
        <template slot-scope="scope">
          <div v-if="scope.row.state == 0">待审核</div>
          <div v-if="scope.row.state == 1">审核通过</div>
          <div v-if="scope.row.state == 2">审核失败</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click="getchakanxq(scope.row.houseStockCheckId)"
            >查看详情</el-link
          >
          <el-link
            v-if="scope.row.state == 0"
            style="margin: 0 20px"
            type="primary"
            @click="getchakxq(scope.row.houseStockCheckId)"
            >审核</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>

    <el-dialog
      title="审核库存"
      :visible.sync="addORUpdateVisible"
      width="500px"
      @close="getshenhei"


    >
      <div v-if="wo">
        <div class="t1">是否同意库存变更</div>

        <div class="shanc">
          <el-button @click="quxiao">取消</el-button>
          <el-button type="primary" @click="getchue">确定</el-button>
        </div>
      </div>

      <div v-else>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="reson"
        >
        </el-input>

        <div class="shanc">
          <el-button @click.native="addORUpdateVisible = false">取消</el-button>
          <el-button type="primary" @click="getqunxdqd">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      reson: "",
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      textarea: "",
      wo: true,
      arr: "",
      id: "",
      keyword: "",
      state: "",
      addORUpdateVisible: false,
      tableData: [],
      shanghai: "",
      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {
    this.getCheckTotal();

    this.getCheckList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {

      getshenhei(){

             this.reson="",
            this.wo=true



   },




    getqunxdqd() {
      this.$api.activitymsg
        .checkyhx({
          checkId: this.id,
          state: 2,
          reson: this.reson,
        })
        .then((e) => {
          if (e.code == 200) {

          this.reson="",
            this.wo=true

            this.getCheckList(this.searlist.curPage, this.searlist.pageSize);
            this.addORUpdateVisible = false;
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getchue() {
      this.$api.activitymsg
        .checkyhx({
          checkId: this.id,
          state: 1,
          reson: "",
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "审核成功",
              type: "success",
            });

            this.getCheckList(this.searlist.curPage, this.searlist.pageSize);
            this.addORUpdateVisible = false;
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getCheckList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getCheckList(v, this.searlist.pageSize);
    },

    getchozi() {
      (this.keyword = ""), (this.state = "");
      this.getCheckList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchakancx() {
      this.getCheckList(this.searlist.curPage, this.searlist.pageSize);
    },

    getCheckList(curr, pagesize) {
      this.$api.activitymsg
        .getCheckList({
          current: curr,
          size: pagesize,
          keyword: this.keyword,
          state: this.state,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getCheckTotal() {
      this.$api.activitymsg.getCheckTotal({}).then((e) => {
        this.arr = e.data;
      });
    },

    getchakanxq(oid) {
      // this.$router.push("yhx");

      this.$router.push({
        path: "yhx",
        query: {
          oid: oid,
        },
      });
    },

    quxiao() {
      this.wo = false;
    },

    getchakxq(id) {
      this.id = id;
      this.addORUpdateVisible = true;
    },
  },
};
</script>

<style scoped>
.shanc {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 30px 0; */
}

.t1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.con-let {
  height: 50px;
}

.a7 {
  width: 700px;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
